module.exports = __webpack_public_path__ + "img/160049.dc946a31.png";